<template>
	<span class="pronto-tag" :class="{ large, primary, danger }"><slot /></span>
</template>

<script>
export const sizes = {
	LARGE: 'large',
}
export const types = {
	PRIMARY: 'primary',
	DANGER: 'danger',
}

export default {
	name: 'Tag',
	props: {
		// type props are just boolean flags
		...Object.values(types).reduce(
			(acc, t) => ({ ...acc, [t]: { type: Boolean, default: null } }),
			{}
		),
		// size props are just boolean flags
		...Object.values(sizes).reduce(
			(acc, s) => ({ ...acc, [s]: { type: Boolean, default: null } }),
			{}
		),
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.pronto-tag {
	padding: 2px 2px 1px 2px;
	text-transform: uppercase;
	border-radius: 3px;
	font-size: 9px;
	color: var(--neutral-800);
	border: 1px solid var(--neutral-800);
	flex-shrink: 0;
	&.large {
		font-size: 12px;
		padding: 4px 4px 3px 4px;
	}
	&.primary {
		color: var(--blue-300);
		border-color: var(--blue-300);
	}
	&.danger {
		color: var(--red-200);
		border-color: var(--red-200);
	}
}
</style>
